module.exports = __webpack_public_path__ + "img/DE05727.695810c9.png";